import React, {Component} from 'react';
import {COMPANY_API_URL} from "../../constants/api_routes";
import {Button, Form, Grid, Header, Label, Segment,Message} from "semantic-ui-react";
import ListingContainer from "../../containers/listing_container";
import {getTemplateList} from "../../data/report_template_api";


class CreateCompany extends Component {
    constructor(props) {
        super(props);
        this.state = {
            templateId: undefined,
            invoiceFrequency: undefined,
            templateIdValid: true,
            invoiceFrequencyValid: true,
            templates:[],
            showMessage: false
        }
    }

    componentWillMount(){
        getTemplateList().then((response)=>{
            let newObj = [];
            for (let i = 0; i < response.length; i++) {
                let obj = {
                    key: response[i]['report_template'].id,
                    text: response[i]['report_template'].name,
                    value: response[i]['report_template'].id
                };
                newObj.push(obj);
            }
            this.setState({templates:newObj});
        });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        if (!this.state.templateId) {
            this.setState({templateIdValid: false});
            return
        }
        if (!this.state.invoiceFrequency) {
            this.setState({invoiceFrequencyValid: false});
            return
        }
        const formData = new FormData(event.target);
        formData.append("report_template_id", this.state.templateId);
        formData.append("invoice_frequency", this.state.invoiceFrequency);
        this.props.create(COMPANY_API_URL, formData, this.handleCreateResponse,this.props.cancel);

    };

    handleCreateResponse = (response) => {
        if (response.success || response.company) {
            this.setState({showMessage:true});
            setTimeout(()=>{this.props.close()},2000);
        }
        else {
            this.setState({errorMessage: response.responseMessage})
        }
    };

    render() {
        const templateOptions = this.state.templates;
        const invoiceFrequencyOption = [
            {key: 1, text: 'Daily', value: '0'},
            {key: 2, text: 'Monthly', value: '1'},
        ];
        return (
            <div>
                <Header as='h2' textAlign='center'>
                    Create New Company
                </Header>
                {this.state.showMessage && <Message positive onDismiss={() => {this.setState({showMessage:false})}}>
                    <Message.Header>
                        Company creation successful!
                    </Message.Header>
                </Message>}
                <Form onSubmit={this.handleSubmit} type="multipart/form-data">
                    <Grid stackable>
                        <Grid.Row>
                            <Grid.Column width={8}>
                                <Segment>
                                    <Label color='blue' ribbon>
                                        Company General Details
                                    </Label>
                                    <p></p>
                                    <Form.Group widths={2}>
                                        <Form.Input label="Company Name" fluid icon='user' iconPosition='left' placeholder='eg: Abc Inc, xyz Ltd'
                                                type='text' name="name"
                                                required/>
                                        <Form.Input label="Company Logo" fluid type='file' name="logo" className="company-logo"/>
                                    </Form.Group>
                                    <Form.Input label="Company Email" fluid icon='at' iconPosition='left'
                                                placeholder='abc@xyz.com,mail@mail.com'
                                                name="email" type="email" required/>
                                    <Form.Input label="Contact Number" fluid icon='mobile' iconPosition='left'
                                                placeholder='4428659286'
                                                type='number' name="phone_number" required/>

                                    <Form.Input label="Point of Contact" fluid icon='user' iconPosition='left'
                                                placeholder='Person In-charge'
                                                type='text' name="point_of_contact"/>
                                    <Form.Group widths={2} className="field">
                                        <Form.Dropdown
                                            label='Report Template'
                                            required
                                            upward
                                            selection
                                            error={!this.state.templateIdValid}
                                            wrapSelection={false}
                                            options={templateOptions}
                                            placeholder='Select Template'
                                            onFocus={()=>this.setState({templateIdValid:true})}
                                            onChange={(e, option) => {
                                                this.setState({templateId: option.value})
                                            }}
                                        />
                                        <Form.Dropdown
                                            label='Invoice Frequency'
                                            required
                                            upward
                                            selection
                                            error={!this.state.invoiceFrequencyValid}
                                            wrapSelection={false}
                                            options={invoiceFrequencyOption}
                                            placeholder='Select frequency'
                                            onFocus={()=>this.setState({invoiceFrequencyValid:true})}
                                            onChange={(e, option) => {
                                                this.setState({invoiceFrequency: option.value})
                                            }}
                                        />
                                    </Form.Group>

                                    <Form.Group widths={2} className="field">
                                        <Form.Input label="Send Invoice To" fluid icon='at' iconPosition='left'
                                                    placeholder='user@abc.com'
                                                    type='email' name="email_invoice" multiple/>
                                        <Form.Input label="Send Report To" fluid icon='at' iconPosition='left'
                                                    placeholder='user@report.com'
                                                    type='email' name="email_report" multiple/>
                                    </Form.Group>
                                </Segment>
                            </Grid.Column>
                            <Grid.Column width={8}>
                                <Grid.Column width={8}>
                                    <Segment>
                                        <Label color='blue' ribbon>
                                           Company Address Details
                                        </Label>
                                        <p></p>
                                        <Form.Input label="Address Line 1" fluid placeholder='Street'
                                                    type='street view' name="line1"
                                                    required/>
                                        <Form.Input label="Address Line 2" fluid placeholder='Landmark'
                                                    type='street view' name="line2"
                                        />
                                        <Form.Input label="Locality" placeholder='Region'
                                                    type='text' name="locality"
                                        />
                                        <Form.Input label="City" placeholder='City'
                                                    type='text' name="city"
                                        />
                                        <Form.Input label="Country" placeholder='Country'
                                                    type='text' name="country"
                                        />
                                        <Form.Input label="Post Code" placeholder='C2PN57'
                                                    type='text' name="postcode" required
                                        />
                                    </Segment>
                                </Grid.Column>
                            </Grid.Column>
                        </Grid.Row>
                        <div className="center-aligned submit-buttons">
                            {this.props.cancel && <Button content="Cancel" type="button" onClick={(e)=>{e.preventDefault();this.props.close()}}/>}
                            <Button primary>Create Company</Button>
                        </div>
                    </Grid>
                </Form>
            </div>
        );
    }

}

export default ListingContainer(CreateCompany);


// WEBPACK FOOTER //
// ./src/views/company/create_company.js